:host {
  @include reset-host;
}

:host .lang-switch {
  color: $grey-dark;
  font-weight: $fw-regular;
  font-size: $fs-lg;
  text-transform: uppercase;
  text-decoration: none;

  &:focus-visible {
    outline: 1px solid rgba($white, 0.8);
    outline-offset: 3px;
  }
}
